var map = {
	"./Bell.svg": 68999,
	"./Discord.svg": 78729,
	"./Google.svg": 26591,
	"./MetaMask.svg": 6323,
	"./Money-exchange.svg": 35505,
	"./Reddit.svg": 94754,
	"./Setting.svg": 7265,
	"./Twitter-old.svg": 96628,
	"./Twitter.svg": 30429,
	"./Wallet.svg": 79965
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 87886;